import { ApprovalRouteDrawer } from '@/features/approving_invoice_reports/components/ApprovalRouteDrawer';
import { FileInfoDrawer } from '@/features/approving_invoice_reports/components/FileInfoDrawer';
import { DrawerTitle } from '@/features/approving_invoice_reports/components/PaymentDetailDrawer/components/DrawerTitle/DrawerTitle';
import { BusinessDocumentsProvider } from '@/features/approving_invoice_reports/components/PaymentDetailDrawer/context/BusinessDocumentsContext';
import { PaymentDetailProvider } from '@/features/approving_invoice_reports/components/PaymentDetailDrawer/context/PaymentDetailContext';
import { DEFAULT_DRAWER_DETAIL_WIDTH } from '@/features/approving_invoice_reports/constants';
import { DraggableDrawer } from '@moneyforward/ap-frontend-components';
import classnames from 'classnames/bind';
import { FC, memo } from 'react';
import { PaymentDetail } from './Detail';
import styles from './Drawer.module.scss';
import { useDrawerWidth } from './hooks/useDrawerWidth';
import { useViewApproveRouteDrawer } from './hooks/useViewApproveRoute';

const cx = classnames.bind(styles);

export type Props = {
  open: boolean;
  onClose: () => void;
  selectedId: string;
};

export const Drawer: FC<Props> = memo(({ open, onClose, selectedId }) => {
  const { width, setWidth } = useDrawerWidth(DEFAULT_DRAWER_DETAIL_WIDTH);
  const {
    isOpen: approvalRouteOpen,
    onDrawerOpen: onOpenApprovalRoute,
    onDrawerClose: onCloseApprovalRoute,
  } = useViewApproveRouteDrawer();

  return (
    <PaymentDetailProvider>
      <BusinessDocumentsProvider>
        <DraggableDrawer
          width={width}
          setWidth={setWidth}
          visible={open}
          onClose={onClose}
          destroyOnClose
          contentContainerClassName={cx(styles['contentContainer'])}
          className={cx(styles['paymentDetailDrawer'])}
          minWidth={DEFAULT_DRAWER_DETAIL_WIDTH}
          title={
            <DrawerTitle
              onOpenApprovalRoute={onOpenApprovalRoute}
              reportId={selectedId}
            />
          }
        >
          <PaymentDetail id={selectedId} onClose={onClose} />
        </DraggableDrawer>
        {approvalRouteOpen && (
          <ApprovalRouteDrawer
            open={approvalRouteOpen}
            reportId={selectedId}
            onCloseDetailDrawer={onClose}
            onClose={onCloseApprovalRoute}
          />
        )}
        <FileInfoDrawer onCloseDetailDrawer={onClose} />
      </BusinessDocumentsProvider>
    </PaymentDetailProvider>
  );
});
Drawer.displayName = 'Drawer';
